// extracted by mini-css-extract-plugin
export default {"recos":"B3-z","productCardOverride":"C3-z","rowHasBadge":"D3-z"};